module.exports = __webpack_public_path__ + "static_pc/img/8.6ab7b934.png";